import React from 'react'
import axios from 'axios'
import {
  IconLayer,
  ScatterplotLayer,
  PathLayer,
  SolidPolygonLayer,
  PolygonLayer,
  GeoJsonLayer,
  BitmapLayer,
} from '@deck.gl/layers'
import { MVTLayer } from '@deck.gl/geo-layers'
import { PathStyleExtension } from '@deck.gl/extensions'
import { getEnv } from 'configurations'
import { parse, fetchFile } from '@loaders.gl/core'
import PowerIcon from '@material-ui/icons/Power'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import HelpIcon from '@material-ui/icons/Help'
import InfoIcon from '@material-ui/icons/Info'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import icons from './layersIcons'
import Tooltip from '@material-ui/core/Tooltip'
import Alert from '@material-ui/lab/Alert'

function Parser(data) {
  const LayerArray = []
  if (data) {
    data.map((obj) => LayerArray.push(Layers(obj)))
  }

  return LayerArray
}

const fetchFunc = async (url, { layer, loaders, loadOptions, signal }) => {
  let controller = new AbortController()
  setTimeout(() => controller.abort(), 1000)
  loaders = loaders || layer.props.loaders

  try {
    const response = await fetch(url, {
      signal: controller.signal,
      method: 'GET',
      // mode: 'cors',
      // credentials: 'include',
    })
    return parse(response, loaders, loadOptions)
  } catch (err) {
    // console.log(err)
    if (err.name == 'AbortError') {
      // se maneja el abort()
      console.log('Aborted!')
    } else {
      // throw err;
    }
  }
}

function capitalize(string) {
  return string[0].toUpperCase() + string.slice(1)
}

function getIconColor(lbl) {
  let color
  switch (lbl) {
    case '400 kV':
      color = '#021ce3'
      break
    case '230 kV':
      color = '#ff9900'
      break
    case '161 kV':
      color = '#5bf06c'
      break
    case '138 kV':
      color = '#78f8ff'
      break
    case '115 kV':
      color = '#ed51e8'
      break
    case '85 kV':
      color = '#fc0000'
      break
    case '69 kV':
      color = '#006b19'
  }
  return color
}

function getIconColorNumber(id) {
  let color
  switch (id) {
    case 500:
      color = '#021ce3'
    case 400:
      color = '#021ce3'
      break
    case 230:
      color = '#ff9900'
      break
    case 220:
      color = '#ff9900'
      break
    case 161:
      color = '#5bf06c'
      break
    case 138:
      color = '#78f8ff'
      break
    case 115:
      color = '#ed51e8'
      break
    case 110:
      color = '#ed51e8'
      break
    case 85:
      color = '#fc0000'
      break
    case 69:
      color = '#006b19'
      break
    case 66:
      color = '#fc0000'
  }
  return color
}

function ShowData(info) {
  let tmp = []
  let body = {}
  // console.log("INFO: ", info)

  //CLICK NORMAL
  if ('click' in info && 'tableData' in info.click === false) {
    for (let i = 0; i < info.click.subtitle.length; i++) {
      if (info.click.subtitleContent[i] || info.click.subtitleContent[i] === 0) {
        tmp.push(
          <div style={{ marginLeft: '15px' }}>
            <b>{info.click.subtitle[i]}:</b>&nbsp;{info.click.subtitleContent[i]}
            <br />
          </div>,
        )
      }
    }
    if (info.click.title[0] === undefined) {
      body = {
        html: (
          <div style={{ fontSize: '14px' }}>
            <div style={{ textAlign: 'center' }}>
              <b>{info.click.titleContent[0]}</b>
            </div>
            {tmp.map((obj) => obj)}
            {info.click.alert && info.click.alert.visible ? (
              <Alert
                style={{
                  fontSize: '10px',
                  padding: '5px 15px 5px 15px',
                  marginTop: '5px',
                  borderRadius: '0px 0px 4px 4px',
                }}
                severity={info.click.alert.type}
              >
                {info.click.alert.message}
              </Alert>
            ) : null}
          </div>
        ),
        data: info,
      }
    }
    if (info.click.title[0] !== undefined) {
      body = {
        html: (
          <div style={{ marginLeft: '15px', fontSize: '14px' }}>
            <b>{info.click.title}: </b>&nbsp;{info.click.titleContent[0]}
            <br />
            {tmp.map((obj) => obj)}
            {info.click.alert && info.click.alert.visible ? (
              <Alert
                style={{
                  fontSize: '10px',
                  padding: '5px 15px 5px 15px',
                  marginTop: '5px',
                  borderRadius: '0px 0px 4px 4px',
                }}
                severity={info.click.alert.type}
              >
                {info.click.alert.message}
              </Alert>
            ) : null}
          </div>
        ),
        data: info,
      }
    }
  }

  //CLICK MARKET INTELIGENCE
  if ('click' in info && 'tableData' in info.click && 'tableTitle' in info.click === false) {
    // console.log(info)
    for (let i = 0; i < info.click.subtitle.length; i++) {
      if (info.click.subtitleContent[i] || info.click.subtitleContent[i] === 0) {
        tmp.push(
          <div style={{ marginLeft: '15px' }}>
            <b>{info.click.subtitle[i]}:</b>&nbsp;{info.click.subtitleContent[i]}
            <br />
          </div>,
        )
      }
    }
    if (info.click.title[0] === undefined) {
      body = {
        html: (
          <div key={info.click.timeLapse} style={{ fontSize: '14px' }}>
            <div style={{ display: 'flex', borderRadius: '4px 4px 0px 0px', background: '#2b2b2b26' }}>
              <div
                id="info-btn"
                class="info-div"
                style={{ background: '#a65e44', color: 'white' }}
                onClick={() => {
                  document.getElementById('infoDiv').style.display = 'block'
                  document.getElementById('permitsTable').style.display = 'none'
                  document.getElementById('info-btn').style.background = '#a65e44'
                  document.getElementById('info-btn').style.color = 'white'
                  document.getElementById('permits-btn').style.background = 'transparent'
                  document.getElementById('permits-btn').style.color = 'black'
                }}
              >
                Info
              </div>
              <div
                id="permits-btn"
                class="permits-div"
                onClick={() => {
                  document.getElementById('infoDiv').style.display = 'none'
                  document.getElementById('permitsTable').style.display = 'block'
                  document.getElementById('info-btn').style.background = 'transparent'
                  document.getElementById('info-btn').style.color = 'black'
                  document.getElementById('permits-btn').style.background = '#a65e44'
                  document.getElementById('permits-btn').style.color = 'white'
                }}
              >
                Permits
              </div>
            </div>
            <div id="infoDiv">
              {tmp.map((obj) => obj)}
              {info.click.alert && info.click.alert.visible ? (
                <Alert
                  style={{
                    fontSize: '10px',
                    padding: '5px 15px 5px 15px',
                    marginTop: '5px',
                    borderRadius: '0px 0px 4px 4px',
                  }}
                  severity={info.click.alert.type}
                >
                  {info.click.alert.message}
                </Alert>
              ) : null}
            </div>
            <table id="permitsTable" style={{ borderCollapse: 'collapse', width: '100%', display: 'none' }}>
              <tr style={{ backgroundColor: '#bdbdbd' }}>
                <th style={{ width: '190px', paddingLeft: '10px', textAlign: 'left' }}>Permits</th>
                <th style={{ width: '75px' }}>Status</th>
              </tr>
              {info.click.tableData.map((obj) => (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#2b2b2b26',
                  }}
                >
                  {obj.reference !== 'To be confirmed' ? (
                    <td style={{ paddingLeft: '10px', display: 'flex', fontSize: '12.4px' }}>
                      {obj.file ? (
                        <a href={obj.file} target="_blank">
                          {obj.permits}
                        </a>
                      ) : (
                        obj.permits
                      )}
                      <Tooltip title={obj.reference}>
                        <InfoIcon
                          style={{
                            fontSize: '16px',
                            alignSelf: 'center',
                            color: '#a65e44',
                            marginLeft: '5px',
                            cursor: 'pointer',
                          }}
                        />
                      </Tooltip>
                    </td>
                  ) : (
                    <td style={{ paddingLeft: '10px', display: 'flex', fontSize: '12.4px' }}>
                      {obj.file ? (
                        <a href={obj.file} target="_blank">
                          {obj.permits}
                        </a>
                      ) : (
                        obj.permits
                      )}
                    </td>
                  )}
                  <td style={{ textAlign: 'center' }}>
                    {obj.status === 'check-icon' ? (
                      <CheckCircleIcon
                        style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#54dd44' }}
                      />
                    ) : obj.status === 'cross-icon' ? (
                      <CancelIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#dd4444' }} />
                    ) : (
                      <HelpIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#b4b4b4' }} />
                    )}
                  </td>
                </tr>
              ))}
            </table>
          </div>
        ),
        data: info,
      }
    }
  }

  //LMP CLICK
  if ('click' in info && 'tableTitle' in info.click) {
    // console.log(info)
    body = {
      html: (
        <div style={{ fontSize: '12px' }}>
          <div className="click-table-title">{info.click.tableTitle[0]}</div>
          <div
            className="click-table-title"
            style={{ borderRadius: '0px', backgroundColor: '#000000', fontSize: '12px' }}
          >
            {info.click.tableSubtitle[0]}
          </div>
          <table style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'center', margin: 'auto' }}>
            <tr style={{ backgroundColor: 'rgb(221, 221, 221)' }}>
              {info.click.tableKeys.map((key) => (
                <th>{capitalize(key)}</th>
              ))}
            </tr>

            <tr
              style={{
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: '#e2e4e8',
              }}
            >
              {info.click.tableKeys.map((key, i) => (
                <td>
                  {i === 0 ? (
                    <PowerIcon
                      style={{
                        fontSize: '16px',
                        top: '2.5px',
                        position: 'relative',
                        color: getIconColor(info.click.tableData[key]),
                      }}
                    />
                  ) : null}
                  {info.click.tableData[key]}
                </td>
              ))}
            </tr>
          </table>
        </div>
      ),
      chartData: info.click.chartData,
    }
  }

  //SubStation
  if ('name_sbn' in info && 'diagrams' in info && 'tableHeaders' in info.click === false) {
    // console.log(info)
    body = {
      html: (
        <div key={info.diagrams}>
          <div className="click-table-title">{info.name_sbn}</div>
          <div className="click-table-title" style={{ borderRadius: '0px', backgroundColor: '#000000' }}>
            Max. Available Capacity
          </div>
          <table style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'center', margin: 'auto' }}>
            {info.bus_500_winter == null &&
            info.bus_400_winter == null &&
            info.bus_220_winter == null &&
            info.bus_230_winter == null &&
            info.bus_161_winter == null &&
            info.bus_138_winter == null &&
            info.bus_110_winter == null &&
            info.bus_115_winter == null &&
            info.bus_85_winter == null &&
            info.bus_69_winter == null &&
            info.bus_66_winter == null ? (
              <thead>
                <tr style={{ backgroundColor: 'rgb(221, 221, 221)' }}>
                  <th style={{ width: '50%' }}>Bus</th>
                  <th style={{ width: '50%' }}>[MW]</th>
                </tr>
              </thead>
            ) : (
              <thead>
                <tr style={{ backgroundColor: 'rgb(221, 221, 221)' }}>
                  <th>Bus</th>
                  <th>Summer [MW]</th>
                  <th>Winter [MW]</th>
                </tr>
              </thead>
            )}
            <tbody>
              {info.bus_500_summer || info.bus_500_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#021ce3' }} />
                    500 kV
                  </td>
                  <td>{info.bus_500_summer}</td>
                  {info.bus_500_winter !== null ? <td>{info.bus_500_winter}</td> : null}
                </tr>
              ) : null}
              {info.bus_400_summer || info.bus_400_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#021ce3' }} />
                    400 kV
                  </td>
                  <td>{info.bus_400_summer}</td>
                  <td>{info.bus_400_winter}</td>
                </tr>
              ) : null}
              {info.bus_230_summer || info.bus_230_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#ff9900' }} />
                    230 kV
                  </td>
                  <td>{info.bus_230_summer}</td>
                  {info.bus_230_winter !== null ? <td>{info.bus_230_winter}</td> : null}
                </tr>
              ) : null}
              {info.bus_220_summer || info.bus_220_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#ff9900' }} />
                    220 kV
                  </td>
                  <td>{info.bus_220_summer}</td>
                  {info.bus_220_winter !== null ? <td>{info.bus_220_winter}</td> : null}
                </tr>
              ) : null}
              {info.bus_161_summer || info.bus_161_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#5bf06c' }} />
                    161 kV
                  </td>
                  <td>{info.bus_161_summer}</td>
                  <td>{info.bus_161_winter}</td>
                </tr>
              ) : null}
              {info.bus_138_summer || info.bus_138_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#78f8ff' }} />
                    138 kV
                  </td>
                  <td>{info.bus_138_summer}</td>
                  <td>{info.bus_138_winter}</td>
                </tr>
              ) : null}
              {info.bus_115_summer || info.bus_115_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#ed51e8' }} />
                    115 kV
                  </td>
                  <td>{info.bus_115_summer}</td>
                  {info.bus_115_winter !== null ? <td>{info.bus_115_winter}</td> : null}
                </tr>
              ) : null}
              {info.bus_110_summer || info.bus_110_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#ed51e8' }} />
                    110 kV
                  </td>
                  <td>{info.bus_110_summer}</td>
                  {info.bus_110_winter !== null ? <td>{info.bus_110_winter}</td> : null}
                </tr>
              ) : null}
              {info.bus_85_summer || info.bus_85_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#ff0000' }} />
                    85 kV
                  </td>
                  <td>{info.bus_85_summer}</td>
                  <td>{info.bus_85_winter}</td>
                </tr>
              ) : null}
              {info.bus_69_summer || info.bus_69_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#006b19' }} />
                    69 kV
                  </td>
                  <td>{info.bus_69_summer}</td>
                  <td>{info.bus_69_winter}</td>
                </tr>
              ) : null}
              {info.bus_66_summer || info.bus_66_summer === 0 ? (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  <td>
                    <PowerIcon style={{ fontSize: '16px', top: '2.5px', position: 'relative', color: '#ff0000' }} />
                    66 kV
                  </td>
                  <td>{info.bus_66_summer}</td>
                  {info.bus_66_winter !== null ? <td>{info.bus_66_winter}</td> : null}
                </tr>
              ) : null}
            </tbody>
            <tfoot>
              {info.cod ? (
                <tr style={{ fontWeight: 'bold', fontSize: '12px', backgroundColor: 'rgb(221, 221, 221)' }}>
                  <td style={{ textAlign: 'end' }}>COD:</td>
                  <td style={{ textAlign: 'start', paddingLeft: '5px' }}>{info.cod}</td>
                </tr>
              ) : null}
            </tfoot>
          </table>
          {info.approx_location ? (
            info.approx_location == 1 ? (
              <div
                style={{
                  display: 'flex',
                  gap: '15px',
                  color: '#663c00',
                  backgroundColor: '#fff4e5',
                  padding: '0px 20px 0px 20px',
                }}
              >
                <ReportProblemOutlinedIcon style={{ color: '#ff9800', alignSelf: 'center', fontSize: '16px' }} />
                <label style={{ alignSelf: 'center', fontSize: '10px' }}>
                  The location of this project is approximate
                </label>
              </div>
            ) : null
          ) : null}
          {/*info.diagrams !== null ?  <div className="onClick-popup">Unifilar Diagram</div> : null*/}
        </div>
      ),
    }
  }

  //SBN Colombia
  if ('click' in info && 'tableHeaders' in info.click) {
    // console.log(info)
    body = {
      html: (
        <div key={info.diagrams}>
          <div className="click-table-title" style={{ pointerEvents: 'none' }}>
            {info.name_sbn}
          </div>
          <div
            className="click-table-title"
            style={{ borderRadius: '0px', backgroundColor: '#000000', pointerEvents: 'none' }}
          >
            Max. Available Capacity
          </div>
          {info.country === 'col' ? (
            <div
              className="click-table-title"
              style={{
                borderRadius: '0px',
                backgroundColor: '#a65e44',
                display: 'flex',
                height: '11px',
                fontSize: '9px',
                lineHeight: '9px',
                pointerEvents: 'none',
              }}
            >
              <div style={{ width: '127px', paddingLeft: '55px' }}>Tycho</div>
              <div style={{ width: '137px' }}>UPME - MACC</div>
            </div>
          ) : null}
          <table style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'center', margin: 'auto' }}>
            <thead>
              <tr style={{ backgroundColor: 'rgb(221, 221, 221)', pointerEvents: 'none' }}>
                {info.click.tableHeaders.map((title) => (
                  <th>{title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {info.click.tableData.map((data, index) => (
                <tr
                  style={{
                    borderTopStyle: 'solid',
                    borderTopWidth: '1px',
                    borderTopColor: '#e2e4e8',
                  }}
                >
                  {info.click.tableHeaders.map((lbl) => (
                    <td>
                      {lbl === 'Bus' ? (
                        <PowerIcon
                          style={{
                            fontSize: '16px',
                            top: '2.5px',
                            position: 'relative',
                            color: getIconColorNumber(data[lbl]),
                          }}
                        />
                      ) : null}
                      {data[lbl]}
                      {lbl === 'Bus' ? ' kV' : null}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tfoot>
              {info.cod ? (
                <tr style={{ fontWeight: 'bold', fontSize: '12px', backgroundColor: 'rgb(221, 221, 221)' }}>
                  <td></td>
                  <td style={{ textAlign: 'end' }}>COD:</td>
                  <td style={{ textAlign: 'start', paddingLeft: '5px' }}>{info.cod}</td>
                  <td></td>
                </tr>
              ) : null}
            </tfoot>
          </table>
          {info.approx_location ? (
            info.approx_location == 1 ? (
              <div
                style={{
                  display: 'flex',
                  gap: '15px',
                  color: '#663c00',
                  backgroundColor: '#fff4e5',
                  padding: '0px 20px 0px 20px',
                }}
              >
                <ReportProblemOutlinedIcon style={{ color: '#ff9800', alignSelf: 'center', fontSize: '16px' }} />
                <label style={{ alignSelf: 'center', fontSize: '10px' }}>
                  The location of this project is approximate
                </label>
              </div>
            ) : null
          ) : null}
          {/*info.diagrams !== null ?  <div className="onClick-popup">Unifilar Diagram</div> : null*/}
        </div>
      ),
    }
  }

  return body
}

function KmlShowData(info) {
  // console.log(info.properties)

  // var values= <div style={{marginLeft:'15px',fontSize:'14px'}}>{Object.keys(info.properties).map(val=>
  //       <div><b>{val}:</b>`${info.properties[val]}`</div>)}</div>

  //console.log(values)
  // Object.keys(info.properties).map(val=> values=values+`<label><b>${val}: </b>${info.properties[val]}</label></br>`)

  return {
    html: (
      <div style={{ marginLeft: '15px', fontSize: '14px' }}>
        <b>Name:</b>&nbsp;{info.properties.name}
        <br />
        <b>Description:</b>&nbsp;{info.properties.description}
        <br />
      </div>
    ),
  }
}

function Hover(info) {
  if ('hover' in info) {
    // console.log(info.hover)
    var values = ''
    {
      info.hover.content.map(
        (val, i) =>
          (values = values + `<label><b>${info.hover.title[i]}:</b>&nbsp;${info.hover.content[i]}</label></br>`),
      )
    }
    return { html: values }

    // if (info.hover.title[0] === undefined) return { html: `<div>${info.hover.content[0]}<br/></div>` }
    // if (info.hover.title[0] !== undefined)
    //   return { html: `<div> <b>${info.hover.title[0]}:</b> ${info.hover.content[0]}<br/></div>` }
  }

  if ('project' in info)
    return { html: `<div> <b>Name:</b> ${info.project === 'NULL' ? info.description : info.project}</div>` }
}

function KmlHover(info) {
  // var values=''

  // Object.keys(info.properties).map(val=> values=values+`<label><b>${val}: </b>${info.properties[val]}</label></br>`)

  return { html: `<div><label><b>Name: </b>${info.properties.name}</label></div>` }
}

function HoverTile(info, key) {
  // console.log(info.properties)
  // if (info.properties.name_agrarian)
  //   return { html: `<div> <b>Agrarian Unit Name:</b> ${info.properties.name_agrarian} </div>` }
  if (info.properties.municipality_name)
    return { html: `<div> <b>Name:</b> ${info.properties.municipality_name} </div>` }
  // if (info.properties.gcv_grupo_fina) return { html: `<div> <b>Name:</b> ${info.properties.gcv_grupo_fina} </div>` }
  // if (info.properties.priority) return { html: `<div> <b>Priority:</b> ${info.properties.priority} </div>` }
  if (info.properties.name_hyd) return { html: `<div> <b>Name:</b> ${info.properties.name_hyd} </div>` }
  if (info.properties.name_sub) return { html: `<div> <b>Name:</b> ${info.properties.name_sub} </div>` }
  if (info.properties.area_type) return { html: `<div> <b>Area Type:</b> ${info.properties.area_type} </div>` }
  if (info.properties.area_name) return { html: `<div> <b>Name:</b> ${info.properties.area_name} </div>` }
  if (info.properties.comunity_name) return { html: `<div> <b>Name:</b> ${info.properties.comunity_name} </div>` }
  if (info.properties.name) return { html: `<div> <b>Name:</b> ${info.properties.name} </div>` }
  // if(info.properties.stone)return { html:`<div> <b>Lithology:</b> ${info.properties.lithology} </div>`}
  if (info.properties.vocation_name) return { html: `<div> <b>Vocation:</b> ${info.properties.vocation_name} </div>` }
  if (key === 'cadastre' && info.properties.economic_destination)
    return { html: `<div> <b>Economic destination:</b> ${info.properties.economic_destination} </div>` }
  if (key === 'cadastre' && !info.properties.economic_destination)
    return { html: `<div> <b>Property Code:</b> ${info.properties.property_code} </div>` }
  if (info.properties.hover) {
    const data = JSON.parse(info.properties.hover)
    return { html: `<div> <b>${data.title}:</b> ${data.content} </div>` }
  }
}

function ShowDataTile(info, key) {
  // if (info.properties.click) {
  //   const data = JSON.parse(info.properties.click)
  //   return {
  //     html: (
  //       <div style={{ marginLeft: '15px', fontSize: '14px' }}>
  //         {data.tags.map((val, i) => (
  //           <div>
  //             <b>{data.tags[i]}:</b>&nbsp;{data.content[i]}
  //           </div>
  //         ))}
  //       </div>
  //     ),
  //   }
  // }
  if (info.properties.click) {
    const data = JSON.parse(info.properties.click)
    const show = JSON.parse(info.properties.click).content.map((val, i) => {
      if (isNaN(val)) {
        return { tag: data.tags[i], content: data.content[i] }
      } else {
        return { tag: data.tags[i], content: Intl.NumberFormat('en').format(data.content[i]) }
      }
    })

    return {
      html: (
        <div style={{ marginLeft: '15px', fontSize: '14px' }}>
          {show
            .filter((obj) => obj.content !== null)
            .map((val, i) =>
              val.content.match(
                /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
              ) ? (
                <div>
                  <a href={val.content} target="_blank">
                    {val.tag}
                  </a>
                </div>
              ) : (
                <div>
                  <b>{val.tag}:</b>&nbsp;{val.content}
                </div>
              ),
            )}
        </div>
      ),
    }
  }
  if (key === 'cadastre') {
    return {
      html: (
        <div style={{ marginLeft: '15px', fontSize: '14px' }}>
          {info.properties.property_code ? (
            <div>
              <b>Property Code:</b>
            </div>
          ) : null}
          {info.properties.property_code ? <div>{info.properties.property_code}</div> : null}
          {info.properties.economic_destination ? (
            <div>
              <b>Economic Destination:</b>&nbsp;{info.properties.economic_destination}
            </div>
          ) : null}
          {info.properties.property_area ? (
            <div>
              <b>Estimated Area [m²]:</b>&nbsp;{Intl.NumberFormat('en').format(info.properties.property_area)}
            </div>
          ) : null}
          {info.properties.total_area_igac ? (
            <div>
              <b>Reported Area [m²]:</b>&nbsp;{Intl.NumberFormat('en').format(info.properties.total_area_igac)}
            </div>
          ) : null}
          {info.properties.adress ? (
            <div>
              <b>Adress:</b>&nbsp;{info.properties.adress}
            </div>
          ) : null}
        </div>
      ),
    }
  }

  if (info.properties.vocation_name) {
    return {
      html: (
        <div style={{ marginLeft: '15px', fontSize: '14px' }}>
          <div style={{ textAlign: 'center' }}>
            <b>Primary Use</b>
            <br />
          </div>
          <div>{info.properties.primary_use}</div>
        </div>
      ),
    }
  }

  if (info.properties.name_sub) {
    return {
      html: (
        <div style={{ marginLeft: '15px', fontSize: '14px' }}>
          <b>Subbasin:</b>&nbsp;{info.properties.name_sub}
          <br />
          <b>Basin:</b>&nbsp;{info.properties.name_bassin}
          <br />
          <b>Region:</b>&nbsp;{info.properties.region}
          <br />
          <b>Area [km2]:</b>&nbsp;{Intl.NumberFormat('en').format(info.properties.area_hyd)}
          <br />
          <b>Perimeter [km]:</b>&nbsp;{Intl.NumberFormat('en').format(info.properties.perimeter)}
          <br />
        </div>
      ),
    }
  }
  if (info.properties.name_hyd && !info.properties.region_hyd) {
    return {
      html: (
        <div style={{ marginLeft: '15px', fontSize: '14px' }}>
          <b>Region:</b>&nbsp;{info.properties.name_hyd}
          <br />
          <b>Area [km2]:</b>&nbsp;{Intl.NumberFormat('en').format(info.properties.area_hyd)}
          <br />
          <b>Perimeter [km]:</b>&nbsp;{Intl.NumberFormat('en').format(info.properties.perimeter_hyd)}
          <br />
        </div>
      ),
    }
  }
  if (info.properties.region_hyd) {
    return {
      html: (
        <div style={{ marginLeft: '15px', fontSize: '14px' }}>
          <b>Basin:</b>&nbsp;{info.properties.name_hyd}
          <br />
          <b>Region:</b>&nbsp;{info.properties.region_hyd}
          <br />
          <b>Area [km2]:</b>&nbsp;{Intl.NumberFormat('en').format(info.properties.area_hyd)}
          <br />
          <b>Perimeter [km]:</b>&nbsp;{Intl.NumberFormat('en').format(info.properties.perimeter_hyd)}
          <br />
        </div>
      ),
    }
  }
}

function svgToDataURL(id) {
  if (id === 'coords-point') return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.redPin())}`
  if (id === 'raster-marker') return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.whitePin())}`
  if (id === 'powerplant_thermal') return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getThermal())}`
  if (id === 'powerplant_cogeneration')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getCogeneration())}`
  if (id === 'powerplant_hydroelectric')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getHydro())}`
  if (id === 'powerplant_solar pv') return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getSolar())}`
  if (id === 'powerplant_combined cycle')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getCombinedCycle())}`
  if (id === 'powerplant_wind') return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getWind())}`
  if (id === 'powerplant_geothermal')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getGeothermal())}`
  if (id === 'powerplant_nuclear') return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getNuclear())}`
  if (id === 'powerplant_biomass') return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getBiomass())}`

  if (id === 'powerplant_hydroelectric_under_construction')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getDevHydro())}`
  if (id === 'powerplant_solar pv_under_construction' || id === 'market_intelligence_powerplant_solar pv')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getDevSolar())}`
  if (id === 'powerplant_wind_under_construction' || id === 'market_intelligence_powerplant_wind')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getDevWind())}`
  if (id === 'powerplant_combined cycle_under_construction')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getDevCombinedCycle())}`
  if (id === 'powerplant_thermal_under_construction' || id === 'market_intelligence_powerplant_thermal')
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getDevThermal())}`

  if (id === 'archeology') return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icons.getArcheology())}`
}

const getTileData = async ({ x, y, z }) => {
  try {
    const response = await axios.get(`https://tu-servidor-de-tiles/${z}/${x}/${y}.pbf`, {
      responseType: 'arraybuffer',
    })
    return response.data
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.warn(`Tesela no encontrada en ${z}/${x}/${y}, ignorando error 404.`)
      return null // Retorna null para teselas no encontradas
    } else {
      console.error('Error al cargar la tesela:', error)
      throw error // Propaga otros errores para que Deck.gl los maneje
    }
  }
}

function Layers(obj) {
  const ICON_MAPPING = { marker: { x: 0, y: 0, width: 128, height: 128, anchorY: 128, mask: true } }

  // if (obj.geotype === 'icon') {
  //   return new IconLayer({
  //     id: obj.id,
  //     data: obj.data,
  //     getColor: d => [255, 140, 0],
  //     section: obj.layer,
  //     getIcon: (d) => 'marker',
  //     getPosition: (d) => d.coordinates,
  //     getSize: (d) => 2,
  //     iconAtlas: obj.design.icon,
  //     iconMapping: ICON_MAPPING,
  //     sizeScale: 8,
  //     pickable: true,
  //     visible: obj.visible,
  //     onHover: (info) => {
  //       if (info?.object) {
  //         info.object = Hover(info.object)
  //       }
  //     },
  //     onClick: (info) => {
  //       if (info?.object) info.object = ShowData(info.object)
  //     },
  //   })
  // }

  if (obj.geotype === 'icon') {
    return new IconLayer({
      id: obj.id,
      data: obj.data,
      getIcon: (d) => ({
        url: svgToDataURL(obj.id),
        width: 128,
        height: 128,
        anchorY: 128,
      }),
      getPosition: (d) => d.coordinates,
      getSize: (d) => 2,
      sizeScale: 8,
      pickable: true,
      visible: obj.visible,
      onHover: (info) => {
        if (info?.object) {
          info.object = Hover(info.object)
        }
      },
      onClick: (info) => {
        if (info?.object) info.object = ShowData(info.object)
      },
    })
  }

  if (obj.geotype === 'point' || obj.geotype === 'atlas_point') {
    return new ScatterplotLayer({
      id: obj.id,
      data: obj.data,
      getFillColor: (d) => (d.specificDesign ? d.specificDesign.color : obj.design.color),
      getLineColor: (d) => (obj.design.lineColor ? obj.design.lineColor : [255, 255, 255]),
      getPosition: (d) => d.coordinates,
      getRadius: (d) => 20,
      radiusMinPixels: obj.design.radius ? obj.design.radius : 5,
      radiusMaxPixels: obj.design.radius ? obj.design.radius * 10 : obj.geotype === 'atlas_point' ? 10 : 50,
      lineWidthMinPixels: 2,
      radiusScale: 10,
      stroked: true,
      opacity: obj.design.opacity ? obj.design.opacity : 0.5,
      pickable: true,
      updateTriggers: {
        getFillColor: obj.design.color,
      },
      visible: obj.visible,
      onHover: (info) => {
        if (info?.object) {
          info.object = Hover(info.object)
        }
      },
      onClick: (info) => {
        if (info?.object) info.object = ShowData(info.object)
      },
    })
  }

  if (obj.geotype === 'geocreator-point') {
    return new ScatterplotLayer({
      id: obj.id,
      data: obj.data,
      getFillColor: (d) => obj.design.color,
      getLineColor: [255, 255, 255],
      getPosition: (d) => d.coordinates,
      getRadius: obj.design.radius,
      radiusMinPixels: obj.design.radius,
      radiusMaxPixels: obj.design.radius,
      lineWidthMinPixels: 2,
      radiusScale: 1,
      stroked: false,
      opacity: 0.8,
      pickable: false,
    })
  }

  if (obj.geotype === 'polygon' || obj.geotype === 'MultiPolygon') {
    return new SolidPolygonLayer({
      id: obj.id,
      data: obj.data,
      // stroked: true,
      pickable: true,
      getFillColor: (d) => (d.specificDesign ? d.specificDesign.color : obj.design.color),
      //getLineColor:  d=> [255,255,255],
      //   getLineWidth: d => 2,
      getPolygon: (d) => d.coordinates,
      //   lineWidthMinPixels: 2,
      opacity: 0.6,
      visible: obj.visible,
      onHover: (info) => {
        if (info?.object) {
          info.object = Hover(info.object)
        }
      },
      onClick: (info) => {
        if (info?.object) info.object = ShowData(info.object)
      },
    })
  }

  if (obj.geotype === 'polygon_border') {
    return new PolygonLayer({
      id: obj.id,
      data: obj.data,
      stroked: true,
      pickable: true,
      getFillColor: (d) => (d.specificDesign ? d.specificDesign.color : obj.design.color),
      getLineColor: (d) => [255, 255, 255],
      getLineWidth: (d) => (obj.design.lineWidth ? obj.design.lineWidth : 3),
      getPolygon: (d) => d.coordinates,
      lineWidthMinPixels: 2,
      opacity: 0.6,
      visible: obj.visible,
      onHover: (info) => {
        if (info?.object) {
          info.object = Hover(info.object)
        }
      },
      onClick: (info) => {
        if (info?.object) info.object = ShowData(info.object)
      },
      updateTriggers: {
        getFillColor: obj.design.color,
      },
    })
  }

  if (obj.geotype === 'line' || obj.geotype === 'atlas_line') {
    return new PathLayer({
      id: obj.id,
      data: obj.data,
      section: obj.layer,
      getColor: (d) => (d.specificDesign ? d.specificDesign.color : obj.design.color),
      getPath: (d) => d.coordinates,
      getWidth: obj.design.lineWidth ? obj.design.lineWidth : 3,
      widthMaxPixels: 6,
      widthMinPixels: 3,
      widthScale: 8,
      parameters: {
        depthMask: false,
      },
      updateTriggers: {
        getColor: obj.design.color,
      },
      pickable: true,
      visible: obj.visible,
      onHover: (info) => {
        if (info?.object) {
          info.object = Hover(info.object)
        }
      },
      onClick: (info) => {
        if (info?.object) info.object = ShowData(info.object)
      },
    })
  }

  if (obj.geotype === 'dotted_line') {
    return new PathLayer({
      id: obj.id,
      data: obj.data,
      section: obj.layer,
      getColor: (d) => (d.specificDesign ? d.specificDesign.color : obj.design.color),
      getPath: (d) => d.coordinates,
      getWidth: obj.design.lineWidth ? obj.design.lineWidth : 3,
      widthMaxPixels: 6,
      widthMinPixels: 3,
      widthScale: 8,
      getDashArray: [4, 3],
      dashJustified: false,
      extensions: [new PathStyleExtension({ highPrecisionDash: true })],
      parameters: {
        depthMask: false,
      },
      updateTriggers: {
        getColor: obj.design.color,
      },
      pickable: true,
      visible: obj.visible,
      onHover: (info) => {
        if (info?.object) {
          info.object = Hover(info.object)
        }
      },
      onClick: (info) => {
        if (info?.object) info.object = ShowData(info.object)
      },
    })
  }

  if (obj.geotype === 'tool_line') {
    return new GeoJsonLayer({
      id: obj.id,
      data: obj.data,

      lineWidthScale: 10,
      lineWidthMinPixels: obj.design.widthMin,

      getLineColor: obj.design.color,

      opacity: obj.design.opacity,
      getLineWidth: obj.design.width,

      visible: obj.visible,
      getDashArray: [3, 2],
      dashJustified: true,
      extensions: [new PathStyleExtension({ dash: true })],
    })
  }

  if (obj.geotype === 'tool_point') {
    return new ScatterplotLayer({
      id: obj.id,
      data: obj.data,
      getFillColor: obj.design.fillColor,
      getLineColor: obj.design.lineColor,
      getPosition: (d) => d,
      getRadius: (d) => (obj.design.radius ? obj.design.radius : 5),
      radiusMinPixels: obj.design.radiusMin ? obj.design.radiusMin : 5,
      lineWidthMinPixels: obj.design.lineWidthMin ? obj.design.lineWidthMin : 1.5,
      radiusScale: obj.design.radiusScale ? obj.design.radiusScale : 4,
      stroked: true,
      opacity: obj.design.opacity ? obj.design.opacity : 0.4,
      autoHighlight: true,
      highlightColor: obj.design.lineColor,
      pickable: true,
      visible: true,
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: false,
          }
        }
      },
    })
  }

  if (obj.geotype === 'tool_polygon') {
    return new GeoJsonLayer({
      id: obj.id,
      data: obj.data,
      extruded: false,
      filled: true,
      getFillColor: (d) => obj.design.fillColor,
      stroked: false,
      pickable: false,
      opacity: obj.design.opacity ? obj.design.opacity : 0.4,
      visible: obj.visible,
    })
  }

  if (obj.geotype === 'marker-point') {
    return new IconLayer({
      id: obj.id,
      data: obj.data,
      getIcon: (d) => ({
        url: svgToDataURL(obj.id),
        width: 128,
        height: 128,
        anchorY: 128,
      }),
      getPosition: (d) => d,
      getSize: (d) => 3,
      // iconAtlas: obj.design.icon,
      // iconMapping: ICON_MAPPING,
      sizeScale: 8,
      pickable: false,
      visible: obj.visible,
      onError: (e) => console.log(e),
    })
  }

  if (obj.geotype === 'tile') {
    return new MVTLayer({
      id: obj.id,
      data: obj.data + getEnv('REACT_APP_MAPBOX_TOKEN'),

      section: obj.layer,
      stroked: true,
      pickable: true,
      minZoom: 2,
      maxZoom: 23,
      getFillColor: (d) => (d.properties.color ? JSON.parse(d.properties.color) : obj.design.color),
      getLineColor: (d) =>
        obj.design.line_color
          ? obj.design.line_color
          : d.properties.lineColor
          ? JSON.parse(d.properties.lineColor)
          : [255, 255, 255],
      getLineWidth: (d) => 2,
      lineWidthMinPixels: obj.design.borderWidth ? obj.design.borderWidth : 1,
      lineWidthMaxPixels: obj.design.borderWidth ? obj.design.borderWidth : 1,
      getDashArray: obj.design.dotted ? [4, 3] : [0, 0],
      dashJustified: false,
      extensions: [new PathStyleExtension({ highPrecisionDash: true })],
      getPointRadius: 20,
      pointRadiusMinPixels: obj.design.radius ? obj.design.radius : 5,
      pointRadiusMaxPixels: obj.design.radius ? obj.design.radius * 10 : 50,
      pointRadiusScale: 10,
      pointType: 'circle',
      opacity: 0.6,
      visible: obj.visible,
      onHover: (info) => {
        if (info?.object) {
          info.object = HoverTile(info.object, obj.id)
        }
      },
      onClick: (info) => {
        if (info?.object) info.object = ShowDataTile(info.object, obj.id)
      },
      onTileError: (err) => (err.message.includes('Failed to fetch resource') ? null : console.error(err)),
    })
  }

  if (obj.geotype === 'kml') {
    return new GeoJsonLayer({
      id: obj.id,
      data: obj.data,
      pickable: true,
      stroked: true,
      filled: true,
      extruded: false,
      pointType: 'circle',
      lineWidthScale: 10,
      lineWidthMinPixels: 2,
      lineWidthMaxPixels: 2,
      getFillColor: (d) =>
        d.geometry.type === 'Polygon' || d.geometry.type === 'GeometryCollection'
          ? obj.design.polygonColor
          : d.geometry.type === 'Point'
          ? obj.design.pointColor
          : [0, 0, 0],
      getLineColor: (d) => (d.geometry.type === 'LineString' ? obj.design.lineColor : [255, 255, 255]),
      radiusScale: 10,
      opacity: 0.8,
      getPointRadius: (d) => 10,
      pointRadiusMinPixels: 5,
      pointRadiusMaxPixels: 15,
      getLineWidth: 2,
      getElevation: 30,
      visible: obj.visible,
      updateTriggers: {
        getFillColor: obj.design.flag,
        getLineColor: obj.design.lineColor,
      },
      onHover: (info) => {
        if (info?.object) {
          info.object = KmlHover(info.object)
        }
      },
      onClick: (info) => {
        if (info?.object) info.object = KmlShowData(info.object)
      },
    })
  }

  if (obj.geotype === 'bitmap') {
    return new BitmapLayer({
      id: obj.id,
      bounds: obj.bounds,
      image: obj.image,
      visible: obj.visible,
    })
  }

  if (obj.geotype === 'bitmap-layer') {
    return new BitmapLayer({
      id: obj.id,
      bounds: obj.bounds,
      image: obj.image,
      visible: obj.visible,
    })
  }
}

export default Parser
